import { supabase } from '@/integrations/supabase/client';

const EXPIRATION_SECONDS = 60 * 60; // 1 hora

// Cache simples para evitar chamadas repetidas
const signedUrlCache = new Map<string, { url: string; expiresAt: number }>();

/**
 * Generates a signed URL for an attachment stored in the support-attachments bucket
 * URLs expire after 1 hour for security
 */
export const getAttachmentSignedUrl = async (filePath: string): Promise<string | null> => {
  if (!filePath) return null;

  // Verificar cache
  const cached = signedUrlCache.get(filePath);
  if (cached && cached.expiresAt > Date.now()) {
    return cached.url;
  }

  // Gerar nova signed URL
  const { data, error } = await supabase.storage
    .from('support-attachments')
    .createSignedUrl(filePath, EXPIRATION_SECONDS);

  if (error || !data?.signedUrl) {
    console.error('Error generating signed URL:', error);
    return null;
  }

  // Cachear (expira 5 min antes para segurança)
  signedUrlCache.set(filePath, {
    url: data.signedUrl,
    expiresAt: Date.now() + (EXPIRATION_SECONDS - 300) * 1000
  });

  return data.signedUrl;
};
